export interface ErrorResponse {
  errors: string[];

  /**
   * Список кодов ошибок:
   *     LOCKED_PAYCONTROL - Признак блокировки PayControl на сервере
   */
  codes?: string[];
}

export type EmptyResponse = object;

// @ts-ignore
export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

export enum ContentType {
  JSON = "application/json",
  FORM_DATA = "multipart/form-data",
  URL_ENCODED = "application/x-www-form-urlencoded",
}

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl">;
}
